import * as React from 'react';
import { tag } from '../../../../model/tag';
import { StyledComponentProps, Typography, Grid } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import { ChromePicker } from 'react-color';
import { Category } from '../../../../ui-components/Icons';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';
import CancelButton from '../../../../ui-components/Button/CancelButton';

interface ITagItemProps extends StyledComponentProps {
    tag: tag;
    save: (tag: tag) => any;
    undo: (id: string) => void;
    readonly?: boolean;
    onChange: (tag: tag) => any;
}

export const Detail = (props: ITagItemProps) => {
    const { readonly, tag, onChange, classes } = props;
    return (<Grid container>
        <Grid item sm={12}>
            <TextField label='CODICE' value={tag.code} disabled={readonly} onChange={(val) => onChange({ ...tag, code: val })} />
            <TextField label='DESCRIZIONE' value={tag.description} disabled={readonly} onChange={(val) => onChange({ ...tag, description: val })} />
        </Grid>
        <Grid container className={classes.colorSection}>
            {/* <Grid item xs={12} sm={12} md={6} className={classes.colorSectionItem}>
                <Typography>Font</Typography>
                    <RadioGroup className={classes.textColorRadioGroup} aria-label="position" name="position" value={tag.color} onChange={(e, val) => onChange({ ...tag, color: val })} row>
                        <FormControlLabel
                            value="#FFFFFF"
                            control={<Radio color="primary" />}
                            label="White"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            value="#000000"
                            control={<Radio color="primary" />}
                            label="Black"
                            labelPlacement="end"
                        />
                    </RadioGroup>
            </Grid> */}
            <Grid item xs={12} sm={12} md={6} className={classes.colorSectionItem}>
                <Typography>Colore carettere</Typography>
                <ChromePicker
                    color={tag.color}
                    onChangeComplete={(val) => onChange({ ...tag, color: val.hex })}
                />
            </Grid>
            <Grid item xs={12} className={classes.detailSample}>
                <Category style={{ fill: tag.color }} />
                <Typography style={{ color: tag.color }} className={classes.detailSampleText}>TESTO DI PROVA ESEMPIO DI VISUALIZZAZIONE</Typography>
            </Grid>
            <Grid item xs={12} className={classes.detailButtonsContainer}>
                <SaveIconButton onClick={() => props.save(props.tag)} />
                <CancelButton onClick={() => props.undo(props.tag._id)} />
            </Grid>
        </Grid>
    </Grid >
    );
}